
const initConsoleFilter = () => {
    if (process.env.NODE_ENV !== 'development') {
        return;
    }

    const originalWarn = console.warn;
    const originalError = console.error;
    const originalLog = console.log;

    const suppressPatterns = [
        /\[Violation\].*passive event listener/i,
        /Grammarly\.js/,

        /Cross-Origin-Opener-Policy/,
        /accounts\.google\.com/,
        /BroadcastChannel/,

        /DevTools failed to load source map/,
        /Download the React DevTools/,

        /Extension context/,
        /chrome-extension:/
    ];

    const shouldSuppress = (args) => {
        if (!args || !args.length) return false;

        const message = String(args[0]);

        return suppressPatterns.some(pattern => pattern.test(message));
    };

    console.warn = function() {
        if (!shouldSuppress(arguments)) {
            originalWarn.apply(console, arguments);
        }
    };

    console.error = function() {
        if (!shouldSuppress(arguments)) {
            originalError.apply(console, arguments);
        }
    };

    if (process.env.REACT_APP_SUPPRESS_VERBOSE_LOGS === 'true') {
        console.log = function() {
            if (!shouldSuppress(arguments)) {
                originalLog.apply(console, arguments);
            }
        };
    }

    originalLog('%c🔇 Third-party console warnings are being filtered', 'color: #888; font-style: italic;');
};

export default initConsoleFilter;